import * as IconSelector from '../icons';

export const prioridades = [
    {
        value: 'Alta',
        label: 'Alta',
        description: 'Prioridad Alta',
        icon: IconSelector.PriorityHighIcon,
        color: 'DarkRed'
    },
    {
        value: 'Media',
        label: 'Media',
        description: 'Prioridad Media',
        icon: IconSelector.PriorityNormalIcon,
        color: 'DarkOrange'
    },
    {
        value: 'Baja',
        label: 'Baja',
        description: 'Prioridad baja',
        icon: IconSelector.PriorityDownIcon,
        color: 'Green'
    }
];
